export const templateData = [{
        "id": 26,
        "title": "Tim & Tina 100% Pure Mulberry Luxury Silk Satin Pillowcase,Good for Skin and Hair (Standard, Butterfly Flying)",
        "tags": [
            "SALE!All 100% 16mm mulberry silk, the most comfortable silk pillowcase available.",
            "Dermatologist recommended for silk's natural hydrating properties, silk does not absorb face creams like cotton can. Silk pillowcase help make the hair more smooth, avoid morning bed head. Best choice for those who have long or curly hair.",
            "Hidden zipper design, comfort and better fit, help prevent the pillow from slipping out.",
            "Soft, strong, silky, smooth and breathable natural fiber, luxurious silk on both sides.",
            "Standard size is 20 x 26 inches(51cm x 66cm)."
        ],
        "keywords": [
            "100% Pure Mulberry Luxury Silk",
            "Satin Pillowcase",
            "Good for Skin and Hair",
            "Standard",
            "Butterfly Flying"
        ],
        "sku": "20200710122300506",
        "brand": "Tim & Tina",
        "description": "Mulberry silk\nMulberry silk is the highest quality silk available for purchase. The unique thing about Mulberry silk is how it is produced. Mulberry silkhas its history in China, where local farmers grow mulberry leaves for silkworms to feed on. The resulting cocoons are spun into raw Mulberry silk fibres.\nMomme weights Mommes (mm) are units of weight traditionally used to measure the density of silk. It is similar to the use of thread count for cotton fabric. The higher momme number the thicker. \nSkincare It¡¯s long been a secret of the beauty industry that silk pillowcases can make an amazing difference to the appearance of your skin. Wrinkles appear smoother and there are no creases or marks from the pillowcase.\nHair care Wake up in the morning with hair that¡¯s smooth as silk. The natural proteins present in silk together with its amazing smoothness mean that your hair doesn¡¯t get matted or dried out when your head rests on silk overnight. .That¡¯s why top models always insist on silk pillowcases.\nEasy Care\nSilk pillowcases, sheets and duvet covers are easy to launder. They can be machine washed at 30¡ãC on the gentle or hand washable cycle of your washing machine using a gentle, non-biological soap or a specialist silk detergent .Washed in this way will give you years of life, because we always insist the finest, most durable, heavyweight silk.\n\n",
        "image": "/resource/product/editor/261.jpg?v=1",
        "attachments": [
            "/resource/product/editor/261.jpg?v=1",
            "/resource/product/editor/262.jpg?v=1",
            "/resource/product/editor/263.jpg?v=1"
        ],
        "suitCountry": [],
        "suitFestival": [],
        "price": 19.99,
        "upc": "345645744675",
        "hasPowder": false,
        "hasLiquid": false,
        "hasBattery": false,
        "hasReturn": false,
        "hasRefund": false
    },
    {
        "id": 19,
        "title": "EAONE 3 Pcs Hand Folding Fan, Abanicos de Mano Chinese Vintage Style Handheld Fan with Fabric Sleeve, Silk Fan with Bamboo Frame and Elegant Tassel for Party Wedding Dancing Decoration",
        "tags": [
            "Premium Material: Made of silk fabrics, the fan is durable and elegant, doesn't rip as easily as a paper folding fan. With safe and harmless bamboo frame and fan handle, you can feel the unvarnished sense which is differ from plastic one, and enjoy yourself with natural breeze feel",
            "Elegant Design: Painting with flowers and butterflies, makes these fans full of freshness. Each one comes with a fabric sleeve to keep the fan safe and closed when not in use. The delicate and elegant fans design with the style of traditional Chinese ink painting and delicate tassel pendant",
            "Suitable Size: The unfolding size of the fan is 15 inch*8.2 inch, while the folded length is 8.3 inch. It is very lightweight and convenient to carry and fold whether you are outdoor or indoor",
            "Unique Gift: 3 pieces of hand held folding fan in traditional Chinese ink painting style with tassel and the fan cover, nice gifts to woman, girls and lady with their different dress or dance outfit",
            "Widely Use: It can keep you cooler from hot flash in summer and can be used for dancing, stage props, party, gifts, weddings. Also prefect for home interior walls decor such as living room, bedroom, kitchen, bathroom, guest room, office and others"
        ],
        "keywords": [
            "Hand Folding Fan",
            "Chinese Vintage Style ",
            "Handheld Fan with Fabric Sleeve",
            "Silk Fan with Bamboo Frame",
            "Elegant Tassel for Party Wedding Dancing Decoration"
        ],
        "sku": "20200628170704319",
        "brand": "EAONE ",
        "description": "EAONE Hand Folding Fans\n\nSpecification\nWeight:100g\nPackage Size: 24*13*1.5 cm\nUnfolding Size of The Fan: 15 inch*8.2 inch\nFolded Length of The Fan: 8.3 inch\nMaterial: Silk fabrics & bamboo frame \nPacking: Each one comes with a separate plastic bag and fabric sleeve\n\nPackage Include\n3 x Hand Folding Fan with tassel and fan cover",
        "image": "/resource/product/editor/191.jpg",
        "attachments": [
            "/resource/product/editor/191.jpg",
            "/resource/product/editor/192.jpg",
            "/resource/product/editor/193.jpg",
            "/resource/product/editor/194.jpg",
            "/resource/product/editor/195.jpg",
            "/resource/product/editor/196.jpg",
            "/resource/product/editor/197.jpg"
        ],
        "suitCountry": [],
        "suitFestival": [],
        "price": 9.99,
        "upc": "195063827741",
        "hasPowder": false,
        "hasLiquid": false,
        "hasBattery": false,
        "hasReturn": false,
        "hasRefund": false
    },
    {
        "id": 18,
        "title": "E&A Portable Chinese Kongfu Tea Set Travel Ceramic Porcelain Tea Ware Teapot Canister Teacups Tea Clip Towel Tray (B)",
        "tags": [
            "1 teapot, 4 teacups, 1 tea tray, and 1 tea canister combo set",
            "Teapot capacity: 200ml Teacup capacity: 40ml Canister capacity:340ml",
            "Material: ceramic",
            "Packing: travel bag (23cm/9.1in*23cm/9.1*13cm/5.1in)",
            "Weight:about 1.8kg"
        ],
        "keywords": [
            "Chinese",
            "Kongfu Tea Set",
            "Ceramic",
            "Porcelain",
            "Tea",
            "Teapot"
        ],
        "sku": "20200628170704318",
        "brand": " Darunyao",
        "description": "\nMaterial: ceramic\n\nPacking: travel bag \nTeapot capacity: 200ml/7oz\n\nPackage included:\n\n1* Teapot \n4* Teacups \n1* Tea canister \n1* Tea tray \n1* Tea clip \n1* Towel",
        "image": "/resource/product/editor/181.jpg",
        "attachments": [
            "/resource/product/editor/181.jpg",
            "/resource/product/editor/182.jpg",
            "/resource/product/editor/183.jpg",
            "/resource/product/editor/184.jpg",
            "/resource/product/editor/185.jpg",
            "/resource/product/editor/186.jpg",
            "/resource/product/editor/187.jpg"
        ],
        "suitCountry": [],
        "suitFestival": [],
        "price": 42.98,
        "upc": "988987608802",
        "hasPowder": false,
        "hasLiquid": false,
        "hasBattery": false,
        "hasReturn": false,
        "hasRefund": false
    },
    {
        "id": 17,
        "title": "Yan Hou Tang Ming Dynasty Style Chinese Handmade JianZhan Tenmoku West Tea Cup Bowl - 70ml 2.5Oz Small Meditation Holy Water Lotus Pattern Crafts Designer Collection Ceremony Crafted",
        "tags": [
            "Crafts Style - Lotus Pattern Small Meditation Metal Clay ; It is a Holy cup in the past; The pattern of cups is similar, they are not exactly ; The color maybe a little deep or light.",
            "Culture of Crafts - Yan Hou Tang is JianZhan Association in China, the main job is popularize culture to oversea. The technology of made revert from Song Dynasty, Today only few maker can made it.",
            "Applies more widely - Tea, Ceremory, Matcha, Coffee, Wine, Water ; Classical decoration : Home, Office, Club, Livingroom, Lobby, Kitchen",
            "Dimension & Spcification - Ø 7.5 x 3.8cm ; Weight: 115g ; Capacity: 70ml / 2.5Ounces - Specifial Feature: Infusion water, Color will be change / Water fast cooling down / The tea will be better taste",
            "Collectable & Valuable - This is a vintage craft.Get more Knowledge information, Service and learn more, just in \" Yan Hou Tang \""
        ],
        "keywords": [
            "Yan Hou Tang ",
            "Chinese",
            "Handmade",
            "JianZhan"
        ],
        "sku": "20200628170704317",
        "brand": "Yan Hou Tang",
        "description": "Jianzhan is a ancient Chinese tea cup, it used the unique clay from Shuiji Town of Fujian Province to make iron tires. The local mineral glaze rock is added into the ash water to make glaze water. It is burned into the kiln and burned at a high temperature of about 1300 degrees to form a stable state. It is safe and non-toxic.\n\nThe five kinds of JianZhan gone through five dynasties ~ Tang, Song, Yuan, Ming and Qing dynasties respectively.\n\nTang - Big spot egg tea cup\nSong - lantern tea cup\nYuan - Small spot egg tea cup\nMing - Small Meditation Ancient tea cup\nQing - Hundred flowers tea cup\nFive kinds of JianZhan, deducting different time and space changes\nGrain Classification Of Jian Zhan\nJianZhan enamel has a variety of patterns, mainly metamorphosis, rabbits, oil drops, freckles, etc. The names of these buildings are also named according to the ornamentation.\n\nFreckle eye-catching plaque is a relatively expensive product in the construction of kiln products. Its natural glaze tone and warm texture, using the ancient poems to praise: \"Yupeng pattern brush freckle\", \"spotting in the spring spot\" can be seen how precious and elegant the glare of the eye. It is worthy of taste and collection.\nThe Benefits Of JianZhan\nThe unique iron tires of JianZhan contain weak magnetic properties. It is well known that the importance of magnetic fields to living organisms, like sunlight and air pollutants, constitutes an indispensable basic element of biology. According to scientific research, the benefits of magnetic fields to human body are:\n\n1. Promote cell metabolism and balance endocrine.\n\n2. Improve the body's resistance and enhance the immune system.\n\n3. Eliminate excess free radicals in the human body and delay aging.\nImportant elements in JianZhan\nThe high iron content of JianZhan can play the role of living water and soft water. The water quality of JianZhan tea is much softer and sweeter. With the JianZhan products, you will feel the water and milk blending, sweet and smooth, full of tea, deep and deep flavor, dark and fragrant.",
        "image": "/resource/product/editor/171.jpg",
        "attachments": [
            "/resource/product/editor/171.jpg",
            "/resource/product/editor/172.jpg",
            "/resource/product/editor/173.jpg",
            "/resource/product/editor/174.jpg",
            "/resource/product/editor/175.jpg",
            "/resource/product/editor/176.jpg",
            "/resource/product/editor/177.jpg"
        ],
        "suitCountry": [],
        "suitFestival": [],
        "price": 25.99,
        "upc": "916624749002",
        "hasPowder": false,
        "hasLiquid": false,
        "hasBattery": false,
        "hasReturn": false,
        "hasRefund": false
    },
    {
        "id": 16,
        "title": "BandTie Convenient Travel Office Loose Leaf Tea Brewing System-Chinese Jingdezhen Blue and White Porcelain Tea Cup Infuser 4-Piece Set with Tea Cup Lid and Saucer (Blue and White Porcelain)",
        "tags": [
            "Made of Chinese Jingdezhen Blue and White Porcelain.",
            "Capacity:350ml/12 OZ.",
            "Easy to use,perfect for travel or office meeting and so on.",
            "Hand wash only.",
            "Package Include:1 Lid,1 Saucer,1 Cup and 1 Infuser."
        ],
        "keywords": [
            "Chinese",
            "Jingdezhen",
            "Blue and White",
            "Porcelain",
            "Tea Cup "
        ],
        "sku": "20200628170704316",
        "brand": "BandTie",
        "description": "Color:Blue and White Porcelain\nWHAT IS BLUE AND WHITE PORCELAIN\nBlue and white porcelain,also known as the white ground blue and white porcelain, often referred to as \"blue and white\".\nIt is one of the mainstream of Chinese porcelain.\n“blue and white\"is to use natural materials in white mud painting decoration, then cover in a transparent glaze,\nand then the next firing on high temperature,1300 degrees Celsius high-temperature calcination, \nmake the pigment sufficient penetration in billet glaze, rendering the beautiful and luxuriant. \nThen,it will appear blue color decorative pattern, which is deep and remote,bright and clean simple but elegant.\n\nBandTie 4-Piece personal teacup,1 set include a cup lid,a cup,a tea strainer and a saucer.\nThis is a professional tea cup,Suitable for all kinds of black tea,green tea,flower tea and pu'er tea.\nENJOY YOUR TEA\n★ When you are meeting in the meeting room, you can make a cup of strong tea to take in.\n★ When you are reading a book quietly in the study room, you can make a cup of green tea to take in.\n★ When you appreciate the outside flowers in your house,you can make a cup of jasmine tea with this teacup......\n\nHOW TO MAKE YOUR TEA WITH THIS TEACUP\n1.Choose the tea you like to drink and the boiling water.\n2.Put suitable amount of tea leaves into the filter and set in the tea body.\n3.Pour boiling fresh water in.Normally speaking,we will not drink the tea for the first time make.\nWe call the first time make is wash tea leaves.Someone may be wash twice or more.\n4.Soak the tea leaves in the filter for a while(about 5-20 second).\n5.Take out your tea strainer,you can put it on the saucer.It's very convenience.",
        "image": "/resource/product/editor/161.jpg",
        "attachments": [
            "/resource/product/editor/161.jpg",
            "/resource/product/editor/162.jpg",
            "/resource/product/editor/163.jpg"
        ],
        "suitCountry": [],
        "suitFestival": [],
        "price": 19.95,
        "upc": "864712055647",
        "hasPowder": false,
        "hasLiquid": false,
        "hasBattery": false,
        "hasReturn": false,
        "hasRefund": false
    },
    {
        "id": 15,
        "title": "Dehua Porcelain Ice Crack Chinese Kung Fu Teaset,porcelain China Gong Fu Tea Set,1teapot & 1tea Cup,portable Travel Tea Set (Light blue)",
        "tags": [
            "The traditional manual craft, the high temperature burn, healthy environmental protection",
            "Design is delicate and easy, practical and simple and convenient",
            "Dehua porcelain quality goods item capacity : teapot about 160ML /teacup 80ML",
            "It suitable for green tea, flower tea, pu-er tea,coffee and other office ,outdoor ,travel and daily useing",
            "100% Handmade in Dehua,China"
        ],
        "keywords": [
            "Dehua Porcelain ",
            "Ice Crack ",
            "Chinese ",
            "Kung Fu Teaset",
            "porcelain ",
            "China Gong Fu Tea Set"
        ],
        "sku": "20200628170704315",
        "brand": "Dehua Porcelain",
        "description": "Color:Light Blue\nThe tea sets is famous for its ice crack surface. It suitable for green tea, flower tea, pu-er tea,coffee and other office ,outdoor ,travel and daily useing.",
        "image": "/resource/product/editor/151.jpg",
        "attachments": [
            "/resource/product/editor/151.jpg",
            "/resource/product/editor/152.jpg",
            "/resource/product/editor/153.jpg"
        ],
        "suitCountry": [],
        "suitFestival": [],
        "price": 25.0,
        "upc": "135645186655",
        "hasPowder": false,
        "hasLiquid": false,
        "hasBattery": false,
        "hasReturn": false,
        "hasRefund": false
    },
    {
        "id": 14,
        "title": "Teapot Chinese Yixing Genuine Black Sand Heijingan Tea Xishi Pots (6.8oz/200cc)",
        "tags": [
            "Brand: Yixing Yxhupot Xishi pots, Ball filter and sand is elegant natural.",
            "Yixing pot is breathing, it can keep fresh tea leaves.It can also be used as a storage tea utensils, can make the tea very good fermentation.",
            "zisha genuine Natural mud, High temperature burning production, safety and health;Made by hand, production is limited.There are the marks of handmade pot inside.",
            "The pot has a secure rope, a link pot and lid to prevent the lid from falling off; the pot also has a beautiful splendid gift wrap, while the bag is dust and abrasion resistant.",
            "Exquisite workmanship and design.Password carefully, the surface smooth and comfortable."
        ],
        "keywords": [
            "Teapot ",
            "Chinese ",
            "Yixing ",
            "Genuine ",
            "Black Sand ",
            "Heijingan ",
            "Tea ",
            "Xishi Pots "
        ],
        "sku": "20200628170704314",
        "brand": "Yixing black",
        "description": "Size:6.8oz/200cc\nHealth: Many minerals and trace elements in purple sand have health effects on the human body \nBaoxiang: Double pore structure makes tea more fully play \nNatural: the pot only adds air and water \nClassic: original mineral mud, master craftsmanship, with collectible value \n\n[range] use for Green Tea, Black Tea, tea, Oolong Tea, Pu'er Tea, tea, fruit tea and other craft tea utensils, widely used in hotels, coffee, tea, restaurant and other places!",
        "image": "/resource/product/editor/141.jpg",
        "attachments": [
            "/resource/product/editor/141.jpg",
            "/resource/product/editor/142.jpg",
            "/resource/product/editor/143.jpg",
            "/resource/product/editor/144.jpg",
            "/resource/product/editor/145.jpg",
            "/resource/product/editor/146.jpg",
            "/resource/product/editor/147.jpg"
        ],
        "suitCountry": [],
        "suitFestival": [],
        "price": 35.8,
        "upc": "271171302787",
        "hasPowder": false,
        "hasLiquid": false,
        "hasBattery": false,
        "hasReturn": false,
        "hasRefund": false
    },
    {
        "id": 13,
        "title": "DELIFUR Porcelain Chinese Long-quan Celadon Teacup,kungfu Teacup, Fishes and Lotus Pattern,set of 5",
        "tags": [
            "Long-quan celadon represents the Ancient Celadon of the highest level",
            "Exquisite handiwork, delicate decoration",
            "Vivid hand-paintting fishes are like swimming in the jade when green tea is poured in",
            "Bring you a relaxed momnent, best gift for everyone",
            "various in patterns,Capacity:45~65ml，a set of 5"
        ],
        "keywords": [
            "DELIFUR ",
            "Porcelain ",
            "Chinese ",
            "Long-quan ",
            "Celadon ",
            "Teacup",
            "kungfu ",
            "Teacup, "
        ],
        "sku": "20200628170704313",
        "brand": " DELIFUR",
        "description": "Beautiful cups from China\nThe beautiful mountains and rivers as well as the unique resources of china clay within the boundaries of Longquan Zhejiang gave birth to Longquan celadon, a rare treasure and they also created generations of famous celadon craftsmen of wonderful workmanship. Longquan celadon started in the Five Dynasties, reached its summit during the Song and Yuan Dynasties and lasted to the Ming and Qing Dynasties. It is the longest and largest kiln family in the Chinese celadon history. The produce are divided into big groups,that is , white celadon base and cinnabar celadon base with thick glaze. In the group of the Younger Brother Kiln, (also called Longquan Kiln), glaze includes . soft blue glaze , bean green glaze and plum green glaze and so on , among which ,plum green glaze is the most famous and precious. Celadon from the Younger Brother Kiln was said in ancient books to be sparkling, pure and as perfect as jade. \nCeladon with black celadon base and natural glaze crackle is called Elder, Brother Kiln . The celadon mouth appears purple and in the place where base in exposed , it appears black. This is so called “Purple mouth and black foot ”. \nGraceful and refined and dignified , it was one of the five famous kilns of the Song Dynasty.\nChina is the hometown of porcelains.It’s an important creation of the working people of Han nationality.",
        "image": "/resource/product/editor/131.jpg",
        "attachments": [
            "/resource/product/editor/131.jpg",
            "/resource/product/editor/132.jpg",
            "/resource/product/editor/133.jpg",
            "/resource/product/editor/134.jpg",
            "/resource/product/editor/135.jpg",
            "/resource/product/editor/136.jpg",
            "/resource/product/editor/137.jpg"
        ],
        "suitCountry": [],
        "suitFestival": [],
        "price": 17.99,
        "upc": "740070452672",
        "hasPowder": false,
        "hasLiquid": false,
        "hasBattery": false,
        "hasReturn": false,
        "hasRefund": false
    },
    {
        "id": 12,
        "title": "Jingdezhen Bleu et Blanc Porcelaine Vase, Vase Chinois Vase Antique en Céramique,Vase Art Déco pour le Ménage, Bureau, Mariage, Fête",
        "tags": [
            "Material:porcelain,bone china,ceramic",
            "Size: High: 13.4inch/34cm, caliber: 4.9inch/12.5cm, the most diameter 7.9inch/20cm, bottom diameter: 4.1inch/10.5cm",
            "Color:blue and white",
            "With hand painted crafts",
            "Packing list:1 x vase, 1 x base"
        ],
        "keywords": [
            "Jingdezhen",
            "Porcelaine ",
            "Vase"
        ],
        "sku": "20200628170704312",
        "brand": "Ufingo",
        "description": "1.Function:room/home decor accessories,creative vase decor gifts for birthday,Christmas,wedding or centerpiece,cool crafts collection for dad,mom,girl,lady,women or vase lovers/enthusiast. \n2.Package guarantee and broken compensation promise: \nAll of our ceramic vases are packed with foam and shockproof box to prevent broken in the long shipping way. \nIf you receive the product with broken, please take the photo for proof and send it to us within 24 hours after you receive the parcel. We will response to you and arrange the second shipping or refund very soon. \n3.We always here to help you, please contact us if you interesting or have any question about our product.",
        "image": "/resource/product/editor/121.jpg",
        "attachments": [
            "/resource/product/editor/121.jpg",
            "/resource/product/editor/122.jpg",
            "/resource/product/editor/123.jpg",
            "/resource/product/editor/124.jpg",
            "/resource/product/editor/125.jpg",
            "/resource/product/editor/126.jpg",
            "/resource/product/editor/127.jpg"
        ],
        "suitCountry": [],
        "suitFestival": [],
        "price": 62.95,
        "upc": "809726997101",
        "hasPowder": false,
        "hasLiquid": false,
        "hasBattery": false,
        "hasReturn": false,
        "hasRefund": false
    },
    {
        "id": 11,
        "title": "10 Pcs Fine Porcelain Blue and White Rice Pattern Bowls, Cereal Bowls, Rice Bowls with Free 10 Porcelain Spoons Jingdezhen China",
        "tags": [
            "10 pieces of blue and white Chinese Japanese porcelain rice bowls, with free 10 porcelain spoons",
            "Each bowl is 5.12 inches in diameter, 2.5 inches tall",
            "Dishwasher and microwave safe",
            "The most popular bowl in China"
        ],
        "keywords": [
            "Porcelain",
            "Blue and White ",
            "Rice Pattern Bowls",
            "Cereal Bowls",
            "Rice Bowls",
            "Porcelain",
            "Spoons ",
            "Jingdezhen",
            "China"
        ],
        "sku": "20200628170704311",
        "brand": "Festcool",
        "description": "These blue and white porcelain rice bowls are dotted with translucent patterns that are shaped like grains of rice. You can see from the picture that it is like jade. The most famous bowl in China, it has a history of over 500 years in the city of Jingdezhen, the capital of porcelain in China.",
        "image": "/resource/product/editor/111.jpg",
        "attachments": [
            "/resource/product/editor/111.jpg",
            "/resource/product/editor/112.jpg",
            "/resource/product/editor/113.jpg"
        ],
        "suitCountry": [],
        "suitFestival": [],
        "price": 42.98,
        "upc": "102854854523",
        "hasPowder": false,
        "hasLiquid": false,
        "hasBattery": false,
        "hasReturn": false,
        "hasRefund": false
    },
    {
        "id": 9,
        "title": "UNIQUELOVER Asian Silk Scroll & Home Decorate Chinese National Treasure-Pandas Picture Scroll & Wall Scroll Hanging Artwork Painting",
        "tags": [
            "Silk",
            "Imported",
            "Material: Silk. Size: 12\" x 40\"(30cm x 100cm)",
            "The lithograph inside the matting measures 8\" x 17\"",
            "It can be directly linked to the wall, reflecting the elegance.",
            "Deep Chinese culture, ancient Chinese painter's works, can be learned from the picture of ancient Chinese culture and lifestyle.",
            "This decorative painting structure is handmade, traditional craftsmanship, unique in style, and it immediately brings an elegant oriental touch to your space."
        ],
        "keywords": [
            "UNIQUELOVER",
            "Asian ",
            "Silk ",
            "Scroll",
            "Home Decorate ",
            "Chinese ",
            "National Treasure",
            "Pandas ",
            "Hanging Artwork Painting"
        ],
        "sku": "20200628170704309",
        "brand": "UNIQUELOVER",
        "description": "UNIQUELOVER is a responsible seller, attention to detail is always our priority & we will always strive to do our best to resolve your issue and delight our customers.\n\n\nPRODUCT INFORMATION :\nSize : Total 12\" x 40\"\n\nThe lithograph inside the matting measures 8\" x 17\"\n\nMaterial : Silk\n\nBEAUTIFUL HOME DECOR – Every Chinese painting is rich with characteristics of traditional Chinese culture and heritage, making them ideal works of art to furnish the walls of your home with. Making for great conversation pieces.\n\n\n\nDETAILS :\nQuantity: 1 * Chinese National Treasure-Pandas Painting\nIt can be directly linked to the wall, reflecting the elegance.\nThe content of the screen is the works of top Chinese ancient and modern artists. The original works are stored in museums and have been in existence for decades or even hundreds of years. Copy according to the original works in the same proportion, high-definition digital printing, hand-made.\nThe upper and lower ends of the artwork are made of very good wood. The traditional Chinese painting method can be rolled up and carried. It is very special. It gives you a different feeling. It is difficult for you to have it.\nDeep Chinese culture, ancient Chinese painter's works, can be learned from the picture of ancient Chinese culture and lifestyle.\n\n\nIf you like Chinese culture, This Chinese wall scroll can take you to understand more Chinese culture, its original work is written on silk with a brush, is a very precious artwork.\n\nIf you are still worried about party gifts, now is the best choice for you. It will bring more surprises to your party, more happiness, and your friends or relatives will cherish it more.",
        "image": "/resource/product/editor/091.jpg",
        "attachments": [
            "/resource/product/editor/091.jpg",
            "/resource/product/editor/092.jpg",
            "/resource/product/editor/093.jpg",
            "/resource/product/editor/094.jpg",
            "/resource/product/editor/095.jpg",
            "/resource/product/editor/096.jpg",
            "/resource/product/editor/097.jpg"
        ],
        "suitCountry": [],
        "suitFestival": [],
        "price": 19.99,
        "upc": "134908006652",
        "hasPowder": false,
        "hasLiquid": false,
        "hasBattery": false,
        "hasReturn": false,
        "hasRefund": false
    },
    {
        "id": 8,
        "title": "King Silk Art Handmade Stereoscopic Embroidery Framed Peacock Oriental Wall Hanging Art Asian Decoration Tapestry Artwork Picture Gifts 31024",
        "tags": [
            "King Silk Art sells only handmade master quality embroidery artwork with real and long-term collectible value.",
            "Silk colors shimmer when light hits and softly glow in dim-dark areas.",
            "Truly unique wall art for gifts and home decor. Unlike anything you've seen before, a beautiful find.",
            "The actual embroidery will vary slightly from the online image due to hand-stitching.",
            "13\"x13\"x0.6\" with wood frame and glass. Please search \"king silk art unframed\" to find our unframed collections."
        ],
        "keywords": [
            "King Silk Art ",
            "Handmade ",
            "Stereoscopic ",
            "Embroidery ",
            "Framed ",
            "Peacock ",
            "Oriental ",
            "Wall Hanging ",
            "Art ",
            "Asian "
        ],
        "sku": "20200628170704308",
        "brand": "King Silk Art ",
        "description": "100% hand-stitched by Master Artists in Suzhou, China. Our artwork, Susho, is completely natural, created with tiny needles and pure silk thread. Susho is a 2500 year old family tradition, with a unique and fascinating history.\n\nIn Feng Shui, orchids are a powerful fertility charm. Orchids also have other powers, their inherent perfection, symbolizes striving to perfect oneself and one's environment. Orchids are also symbolic for strength of character and are a reminder to open oneself up to the flow of beauty and prosperity into our lives.\n\nOur golden orchids attract wealth and fertility, the moon promises harmonious romance, a perfect recipe for a happy marriage.",
        "image": "/resource/product/editor/081.jpg",
        "attachments": [
            "/resource/product/editor/081.jpg",
            "/resource/product/editor/082.jpg",
            "/resource/product/editor/083.jpg",
            "/resource/product/editor/084.jpg",
            "/resource/product/editor/085.jpg",
            "/resource/product/editor/086.jpg",
            "/resource/product/editor/087.jpg"
        ],
        "suitCountry": [],
        "suitFestival": [],
        "price": 55.7,
        "upc": "591008098415",
        "hasPowder": false,
        "hasLiquid": false,
        "hasBattery": false,
        "hasReturn": false,
        "hasRefund": false
    },
    {
        "id": 7,
        "title": "Grace Art, Large Asian Silk Embroidery Art Wall Hanging, Cranes",
        "tags": [
            "Gorgeous, glimmering Grace Art brand silk embroidery art wall hanging featuring a traditional design",
            "Perfect size as a wall decoration or elegant gift, embroidery measures 15\" x 19\" with matting. The embroidery inside the matting measures 14 1/2\" x 10 1/2\". Does NOT come with a frame",
            "Embroidered using 1/4 size silk threads for fine detail and increased value",
            "Enjoy a style of art with over 2,000 years of history",
            "Matted and ready to place in a frame and hang. Does NOT come with a frame. We suggest using a frame with inside dimensions at least 1\" larger than the dimensions of the embroidery."
        ],
        "keywords": [
            "Grace Art, ",
            "Large ",
            "Asian ",
            "Silk ",
            "Embroidery ",
            "Art ",
            "Wall Hanging, ",
            "Cranes"
        ],
        "sku": "20200628170704307",
        "brand": "Grace Art",
        "description": "Our Grace Art brand Asian silk embroidery art wall hangings will add polish and vibrance to any room. Our embroideries are created by rendering the artists original design using silk threads which have been split into 4 fine strands for greater detail, followed by hand finishing the matting and other finishing touches. The result is a vibrant, shimmering work of art that will leave you breathless. Bring a touch of the Far East to your home today with our Asian embroidery designs! Note that our embroideries do NOT ship with frames. Frames are a personal choice and should be carefully chosen to fit the style of the room the art is being hung in, your own personal preference, and the style of the art itself.",
        "image": "/resource/product/editor/071.jpg",
        "attachments": [
            "/resource/product/editor/071.jpg",
            "/resource/product/editor/072.jpg",
            "/resource/product/editor/073.jpg",
            "/resource/product/editor/074.jpg",
            "/resource/product/editor/075.jpg",
            "/resource/product/editor/076.jpg"
        ],
        "suitCountry": [],
        "suitFestival": [],
        "price": 19.99,
        "upc": "940044172052",
        "hasPowder": false,
        "hasLiquid": false,
        "hasBattery": false,
        "hasReturn": false,
        "hasRefund": false
    },
    {
        "id": 6,
        "title": "Grace Art, Large Asian Silk Embroidery Art Wall Hanging, Phoenix",
        "tags": [
            "Gorgeous, glimmering Grace Art brand silk embroidery art wall hanging featuring a traditional design",
            "Perfect size as a wall decoration or elegant gift, embroidery measures 15 1/4\" x 15 1/4\" with matting. The embroidery inside the matting measures 11 3/4\" in diameter. Does NOT come with a frame",
            "Embroidered using 1/4 size silk threads for fine detail and increased value",
            "Enjoy a style of art with over 2,000 years of history",
            "Matted and ready to place in a frame and hang. Does NOT come with a frame. We suggest using a frame with inside dimensions at least 1\" larger than the dimensions of the embroidery."
        ],
        "keywords": [
            "Grace Art",
            "Large ",
            "Asian ",
            "Silk ",
            "Embroidery ",
            "Art ",
            "Wall Hanging, ",
            "Phoenix"
        ],
        "sku": "20200628170704306",
        "brand": "Grace Art",
        "description": "Our Grace Art brand Asian silk embroidery art wall hangings will add polish and vibrance to any room. Our embroideries are created by rendering the artists original design using silk threads which have been split into 4 fine strands for greater detail, followed by hand finishing the matting and other finishing touches. The result is a vibrant, shimmering work of art that will leave you breathless. Bring a touch of the Far East to your home today with our Asian embroidery designs! Note that our embroideries do NOT ship with frames. Frames are a personal choice and should be carefully chosen to fit the style of the room the art is being hung in, your own personal preference, and the style of the art itself.",
        "image": "/resource/product/editor/061.jpg",
        "attachments": [
            "/resource/product/editor/061.jpg",
            "/resource/product/editor/062.jpg",
            "/resource/product/editor/063.jpg"
        ],
        "suitCountry": [],
        "suitFestival": [],
        "price": 19.99,
        "upc": "369737597527",
        "hasPowder": false,
        "hasLiquid": false,
        "hasBattery": false,
        "hasReturn": false,
        "hasRefund": false
    },
    {
        "id": 5,
        "title": "7Fairy Women's Bodycon Black/Red Keyhole Long Chinese Dress Cheongsam",
        "tags": [
            "Size chart is in the \"Product Description\".",
            "Please check the Size Chart & Important Note before buying.",
            "Fabric Care: Dry Clean.",
            "Dress Occasion: Prom, Club, Party, Evening, Special Occasion",
            "Material: Chinese Satin, SKU:1102607"
        ],
        "keywords": [
            "7Fairy ",
            "Women's ",
            "Bodycon ",
            "Black/Red ",
            "Keyhole ",
            "Long Chinese ",
            "Dress ",
            "Cheongsam"
        ],
        "sku": "20200628170704305",
        "brand": "7Fairy ",
        "description": "Tips:\nPlease check the size chart before buying. \n\nSize Chart(Inch)| Bust | Waist | Hips | Shoulder Width | Length | Clothes Size Tag \n_____US 2_______32\"___26\"___34\"______14.2\"_______49.2\"___32 (or Chinese S) \n_____US 4_______34\"___28\"___36\"______14.6\"_______49.6\"___34 (or Chinese M) \n_____US 6_______36\"___30\"___38\"______15.0\"_______50.0\"___36 (or Chinese L) \n_____US 8_______38\"___32\"___40\"______15.5\"_______50.4\"___38 (or Chinese XL) \n_____US 10______40\"___34\"___42\"______15.8\"_______50.8\"___40 (or Chinese XXL) \n_____US 12______42\"___36\"___44\"______16.2\"_______51.2\"___42 (or Chinese 3XL) \n_____US 14______44\"___38\"___46\"______16.6\"_______51.6\"___44 (or Chinese 4XL) \n_____US 16______46\"___40\"___48\"______17.0\"_______52.0\"___46 (or Chinese 5XL) \n_____US 18______48\"___42\"___50\"______17.4\"_______52.4\"___48 (or Chinese 6XL) \n\nImportant Note: \n1.One inch(1\")=2.54cm\n2.The measurements in the size chart are based on clothes. Not your body measurements. So you will choose the size a little Larger (1\"-1.5\") than your body size. If any part of your body especially bust or hips at the upper end of the size ranges then please choose the next larger size range. \n3.If your measurements happen to be between two sizes, please choose the next bigger one.",
        "image": "/resource/product/editor/051.jpg",
        "attachments": [
            "/resource/product/editor/051.jpg",
            "/resource/product/editor/052.jpg",
            "/resource/product/editor/053.jpg",
            "/resource/product/editor/054.jpg",
            "/resource/product/editor/055.jpg"
        ],
        "suitCountry": [],
        "suitFestival": [],
        "price": 55.99,
        "upc": "636214615438",
        "hasPowder": false,
        "hasLiquid": false,
        "hasBattery": false,
        "hasReturn": false,
        "hasRefund": false
    },
    {
        "id": 4,
        "title": "EXCELLANYARD Velvet Chinese Qipao Cheongsam Dresses for Women",
        "tags": [
            "Material: Velvet, Design with half sleeve.",
            "Size 0/2: Bust: 32.5\", Waist: 26\", Hip: 32\"; Size 4: Bust: 34.5\", Waist: 28\", Hip: 34\".",
            "Size 6: Bust: 36\", Waist: 30\", Hip: 36\"; Size 8: Bust: 38\", Waist: 32\", Hip: 38\".",
            "Size 10: Bust: 40\", Waist: 34\", Hip: 40\"; Size 12: Bust: 41\", Waist: 36\", Hip: 42\"."
        ],
        "keywords": [
            "EXCELLANYARD ",
            "Velvet ",
            "Chinese ",
            "Qipao ",
            "Cheongsam ",
            "Dresses Women"
        ],
        "sku": "20200628170704304",
        "brand": "EXCELLANYARD",
        "description": "Usually we free ship goods to United States and Canada via Epacked. \nWe free ship goods to Europe and Australia via Post mail. \nIf you need the goods urgently, please contact us and choose Expedited shipping. ",
        "image": "/resource/product/editor/041.jpg",
        "attachments": [
            "/resource/product/editor/041.jpg",
            "/resource/product/editor/042.jpg",
            "/resource/product/editor/043.jpg",
            "/resource/product/editor/044.jpg"
        ],
        "suitCountry": [],
        "suitFestival": [],
        "price": 35.0,
        "upc": "270445170133",
        "hasPowder": false,
        "hasLiquid": false,
        "hasBattery": false,
        "hasReturn": false,
        "hasRefund": false
    },
    {
        "id": 3,
        "title": "Shanghai Story Chinese Cheongsam Shirt Short Sleeve China Blouse for Women",
        "tags": [
            "Designed for Asian sizes which could be 1 or 1.5 times smaller than the US sizes; Please refer to the size measurement below before ordering",
            "Blend polyester, the material is nice and comfortable",
            "Chinese Traditional elegance, traditional embroidery and Chinese frog closure",
            "Stand collar, Short Sleeve, hidden Zip closure on the side",
            "A decent piece for both casual and special events; parties, weddings, business dinners etc. Same Design Short Dress please refer https://www.amazon.com/dp/B01F27CA1C?ref=myi_title_dp, https://www.amazon.com/dp/B01F29LGRO?ref=myi_title_dp, Same Design Long Dress please refer https://www.amazon.com/dp/B01F7N82SG?ref=myi_title_dp,https://www.amazon.com/dp/B01F7N81W8?ref=myi_title_dp,https://www.amazon.com/dp/B01FAZELWC?ref=myi_title_dp"
        ],
        "keywords": [
            "Chinese ",
            "Cheongsam ",
            "Shirt ",
            "Short Sleeve ",
            "China ",
            "Blouse Women"
        ],
        "sku": "20200628170704303",
        "brand": "Shanghai Story",
        "description": "Feature:\n\n1.The cheongsam Top is a female Shirt with distinctive Chinese features and enjoys a growing popularity in the international world of high fashion.\n\n2.Cheongsam Top make a woman self-confidence, so that women pay more attention to deportment demeanor in public, it will be even more virtuous.\n\nSize Chart\n\nTag Size S):Chest 32.28\",Waist 27.55\",Length 22.04\"\n\nTag Size M):Chest 33.86\",Waist 29.13\",Length 22.83\"\n\nTag Size L):Chest 35.83\",Waist 31.5\",Length 23.62\"\n\nTag Size XL):Chest 37.79\",Waist 33.07\",Length 24.41\"\n\nTag Size 2XL):Chest 39.37\",Waist 34.65\",Length 25.2\"\n\nTag Size 3XL):Chest 40.94\",Waist 36.22\",Length 25.2\"\n\nTag Size 4XL):Chest 41.54\",Waist 37.8\",Length 25.5\"\n\nImportant Note:\n\n1.One inch(1\")=2.54cm\n\n2.The measurements in the size chart are based on clothes. Not your body measurements. So you will choose the size a little Larger (1\"-1.5\") than your body size. If any part of your body especially bust or hips at the upper end of the size ranges then please choose the next larger size range.\n\n3.If your measurements happen to be between two sizes, please choose the next bigger one.",
        "image": "/resource/product/editor/031.jpg",
        "attachments": [
            "/resource/product/editor/031.jpg",
            "/resource/product/editor/032.jpg",
            "/resource/product/editor/033.jpg",
            "/resource/product/editor/034.jpg",
            "/resource/product/editor/035.jpg",
            "/resource/product/editor/036.jpg",
            "/resource/product/editor/037.jpg"
        ],
        "suitCountry": [],
        "suitFestival": [],
        "price": 27.0,
        "upc": "572003755320",
        "hasPowder": false,
        "hasLiquid": false,
        "hasBattery": false,
        "hasReturn": false,
        "hasRefund": false
    },
    {
        "id": 1,
        "title": "oxiuly Women's Vintage Floral Flare Stretch Stand Collar Casual Work Pencil Dress OX183",
        "tags": [
            "65% cotton + 35% polyester",
            "Zipper closure",
            "Material:65% Cotton + 35% Polyester",
            "Design:Stand Collar,Zipper in Left Side.Short sleeve.",
            "Notice:Hand-wash and Machine washable, Dry Clean.",
            "The dress is elegant it self. It's simple but elegant and classy.The dress is really nice and feminine.If you are a little conservative type of person so dress like this always works for you. The length of skirt is enough, not too shorts or too long. The fabric is very soft .You can definitely wear this in special occasions. The stretch material is perfect for movement. The zipper is hot and you toned it down at the office with a cardigan. Accentuates the waist line very well!",
            "Dress it up with heels and a cardigan or with a jean jacket scarf and some boots."
        ],
        "keywords": [
            "oxiuly ",
            "Women",
            "Vintage ",
            "Floral ",
            "Flare ",
            "Stretch ",
            "Stand ",
            "Collar ",
            "Casual ",
            "Work Pencil Dress"
        ],
        "sku": "20200628170704201",
        "brand": "oxiuly",
        "description": "Oxiuly Women's Vintage Floral Flare Stretch Stand Collar Casual Work Pencil Dress\nGender:Women\nStyle:Party,Working,Vintage,Casual \nSeason:Spring,Summer,Fall,winter \nDresses Length:knee-length\nSleeve Length:short sleeve \n\nAs different computers display colors differently, the color of the actual item may vary slightly from the above images, thanks for your understanding.\n\nPlease check your measurements to make sure the item fits before ordering. \n(Please note 1 cm=0.39 inch,1 inch=2.54 cm.)\nPls allow 0.5 inch-1 inch differs due to manual measurements, your understand will be much appreciated!!! \n\nNote:This is the tile size clothes, the fabrics have elastic, you can stretch 5 cm or 1.96 inch space.\n\nSize S:Bust(82 cm/32.28 inch), Waist(68 cm/26.77 inch), Length(99cm/39 inch) \n\nSize M:Bust(87 cm/34.25 inch), Waist(72 cm/28.35 inch), Length(100 cm/39.37 inch) \n\nSize L:Bust(92 cm/36.22 inch), Waist(78 cm/30.7 inch), Length(101 cm/39.76 inch) \n\nSize XL:Bust(97 cm/38.19 inch), Waist(82 cm/32.28 inch), Length(102 cm/40.16 inch) \n\nSize 2XL:Bust(102 cm/40.16 inch), Waist(87 cm/34.25 inch), Length(103 cm/40.55 inch) ",
        "image": "/resource/product/editor/011.jpg",
        "attachments": [
            "/resource/product/editor/011.jpg",
            "/resource/product/editor/012.jpg",
            "/resource/product/editor/013.jpg",
            "/resource/product/editor/014.jpg",
            "/resource/product/editor/015.jpg"
        ],
        "suitCountry": [],
        "suitFestival": [],
        "price": 31.99,
        "upc": "136873001360",
        "hasPowder": false,
        "hasLiquid": false,
        "hasBattery": false,
        "hasReturn": false,
        "hasRefund": false
    }
]
export const templateDefault = {
    title: "",
    tags: [

    ],
    keywords: [],
    sku: "",
    brand: "",
    description: "",
    image: "",
    attachments: [
        "",
        "",
        "",
    ],
    suitCountry: [],
    suitFestival: [],
    price: 0,
    upc: "",
    hasPowder: false,
    hasLiquid: false,
    hasBattery: false,
    hasReturn: false,
    hasRefund: false,
}
export const menuList = [{
        name: '选择合适模板优化产品',
        click: true
    },
    {
        name: '基础信息',
        click: false
    },
    {
        name: '图片编辑',
        click: false
    },
    {
        name: '价格设置',
        click: false
    },
    {
        name: '物流设置',
        click: false
    }
]